import { combineEpics } from 'redux-observable';
import { setArtistToActiveProfileEpic } from '@webapp/store/active-profile/effects/set-artist-to-active-profile';
import { setUserToActiveProfileEpic } from '@webapp/store/active-profile/effects/set-user-to-active-profile';

const activeProfileEpic = combineEpics(
  setArtistToActiveProfileEpic,
  setUserToActiveProfileEpic
);

export default activeProfileEpic;
